import React, {useState} from 'react'
import WhatsAppIcon from '../../../../../../../../assets/icons/platforms/WhatsAppIcon'
import config from "../../../../../../../../config";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import Translate from "../../../../../../../../components/Translate";
import Input from "../../../../../../../../components-new/form/Input";
import {addWhatsAppBot, deleteWhatsAppBot} from "../../../../../../../../services/integrations/api";
import CopyIcon from "../../../../../../../../assets/icons/CopyIcon";
import CheckIcon from "../../../../../../../../assets/icons/CheckIcon";
import colors from "../../../../../../../../utils/Colors";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import Accordion from "../../../../../../../../components-new/ui/Accordion";
import AccordionItem from "../../../../../../../../components-new/ui/Accordion/AccordionItem";
import CircleQuestionMarkIcon from "../../../../../../../../assets/icons/CircleQuestionMarkIcon";
import MinusIcon from "../../../../../../../../assets/icons/MinusIcon";
import PlusIcon from "../../../../../../../../assets/icons/PlusIcon";
import Tooltip from "../../../../../../../../components-new/general/Tooltip";


const webback = config.WEBBACK_HOST;

export const Whatsapp = ({
                             client,
                             whatsAppBot,
                             setWhatsAppBot,
                             addNotification,
                             user
                         }) => {

    const [copiedField, setCopiedField] = useState(null)


    const handleDeleteWhatsAppBot = async () => {
        try {
            const response = await deleteWhatsAppBot(client.id)
            setWhatsAppBot({
                phoneNumberId: "",
                accessToken: "",
                verificationToken: "",
                appSecret: "",
                accountId: "",
                attached: false
            })

            addNotification("deleted", config.notificationLevels.success)
        } catch (e) {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        }
    }

    const handleWhatsAppBotSave = async () => {
        try {
            const response = await addWhatsAppBot({
                phoneNumberId: whatsAppBot.phoneNumberId,
                accessToken: whatsAppBot.accessToken,
                accountId: whatsAppBot.accountId,
                appSecret: whatsAppBot.appSecret
            }, client.id)
            setWhatsAppBot({
                attached: true,
                ...response
            })

            addNotification("added", config.notificationLevels.success)
        } catch (e) {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        }
    }

    const copyToClipboard = async (text, field) => {
        try {
            await navigator.clipboard.writeText(text)
            setCopiedField(field)

            setTimeout(() => {
                setCopiedField(null)
            }, 1000)
        } catch (e) {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        }
    }

    return (
        <div className="bg-white" style={{
            minHeight: 'auto',
            height: 'fit-content',
            maxHeight: 'calc(100vh - 340px)',
            overflow: 'auto',
        }}>
            <div style={{
                width: '100%',
                height: 'auto',
            }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                }}>
                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <WhatsAppIcon width={40} height={40} style={{marginRight: '15px'}}/>
                            <h2>Whatsapp</h2>
                        </div>
                    </div>

                    <Accordion
                        defaultValue={whatsAppBot.attached ? null : '1'}
                        style={{
                            margin: '10px 0'
                        }}
                    >
                        <AccordionItem
                            value="1"
                            triggerContent={
                                <span className="integration-steps">
                                <CircleQuestionMarkIcon/>
                                <Translate text="integrationSteps"/>
                            </span>
                            }
                            triggerIcon={({isOpen}) => {
                                return isOpen() ? <MinusIcon style={{color: colors.silverBlue}} stroke="currentColor" width={18} height={18}/> :
                                    <PlusIcon style={{color: colors.silverBlue}} stroke="currentColor" width={18} height={18}/>
                            }}
                            itemStyle={{
                                background: '#fafafa',
                                borderRadius: '10px',
                                padding: '12px 16px'
                            }}
                        >
                            <div style={{
                                padding: '10px 0 10px 34px',
                                textAlign: 'justify',
                                userSelect: 'text',
                            }}>
                                {user.language === 'en' ?
                                    <ol style={{paddingLeft: '20px', margin: 0}}>
                                        <li style={{marginBottom: '10px'}}>
                                            Go to Meta Developers ( <a href="https://developers.facebook.com"
                                                                       target="_blank"
                                                                       style={{color: 'var(--ds-text-primary)'}}>developers.facebook.com</a> )
                                            and create a new App.
                                            Select <b>Business</b> as the app type.
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            Inside the app dashboard, add the <b>WhatsApp</b> product and complete
                                            the initial setup wizard.
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            Create or connect a <b>Business Portfolio</b> (Business Manager account)
                                            and attach it to your app.
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            In the WhatsApp → API Setup section, you will find:
                                            <ul style={{marginTop: '6px'}}>
                                                <li>Business Account ID</li>
                                                <li>Phone Number ID</li>
                                                <li>Temporary Access Token</li>
                                            </ul>
                                            Copy these values and paste them below.
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            For getting long term token generate a <b>System User Permanent Access
                                            Token</b> from
                                            Business Settings → System Users. Assign the WhatsApp app
                                            and grant required permissions.
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            Copy your <b>App Secret</b> from App Settings → Basic.
                                            This is required to validate webhook signatures.
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            In WhatsApp → Configuration → Webhooks:
                                            <ul style={{marginTop: '6px'}}>
                                                <li>Set the Callback URL to the Webhook URL shown below</li>
                                                <li>Set the Verify Token to the provided Verification Token</li>
                                                <li>Subscribe to <b>messages</b> events</li>
                                            </ul>
                                        </li>

                                        <li>
                                            Save all credentials in this form and complete the setup.
                                            Once attached, incoming messages will be delivered to your webhook.
                                        </li>
                                    </ol>
                                    :
                                    <ol style={{paddingLeft: '20px', margin: 0}}>
                                        <li style={{marginBottom: '10px'}}>
                                            Անցեք Meta Developers ( <a href="https://developers.facebook.com"
                                                                       target="_blank"
                                                                       style={{color: 'var(--ds-text-primary)'}}>developers.facebook.com</a> )
                                            և ստեղծեք նոր App։
                                            Ընտրեք <b>Business</b> որպես հավելվածի տեսակ։
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            Հավելվածի վահանակում ավելացրեք <b>WhatsApp</b> պրոդուկտը և ավարտեք
                                            նախնական կարգավորման գործընթացը։
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            Ստեղծեք կամ կապակցեք <b>Business Portfolio</b> (Business Manager հաշիվ)
                                            և կցեք այն ձեր հավելվածին։
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            WhatsApp → API Setup բաժնում կգտնեք հետևյալ տվյալները՝
                                            <ul style={{marginTop: '6px'}}>
                                                <li>Business Account ID</li>
                                                <li>Phone Number ID</li>
                                                <li>Temporary Access Token</li>
                                            </ul>
                                            Պատճենեք այս տվյալները և տեղադրեք ստորև համապատասխան դաշտերում։
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            Երկարաժամկետ թոքեն ստանալու համար ստեղծեք <b>System User Permanent Access
                                            Token</b>՝
                                            Business Settings → System Users բաժնում։ Կցեք WhatsApp հավելվածը
                                            և տրամադրեք անհրաժեշտ թույլտվությունները։
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            App Settings → Basic բաժնից պատճենեք ձեր <b>App Secret</b>-ը։
                                            Սա անհրաժեշտ է webhook ստորագրության վավերացման համար։
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            WhatsApp → Configuration → Webhooks բաժնում՝
                                            <ul style={{marginTop: '6px'}}>
                                                <li>Callback URL դաշտում տեղադրեք ստորև նշված Webhook URL-ը</li>
                                                <li>Verify Token դաշտում տեղադրեք տրամադրված Verification Token-ը</li>
                                                <li>Բաժանորդագրվեք <b>messages</b> իրադարձությանը</li>
                                            </ul>
                                        </li>

                                        <li>
                                            Պահպանեք բոլոր տվյալները այս ձևում և ավարտեք կարգավորումը։
                                            Կցվելուց հետո մուտքային հաղորդագրությունները կուղարկվեն ձեր webhook հասցեին։
                                        </li>
                                    </ol>
                                }

                            </div>

                        </AccordionItem>
                    </Accordion>

                    {whatsAppBot.attached && (
                        <div className="whatsapp-bot-div">
                            <span>Phone Number ID: {whatsAppBot.phoneNumberId}</span>
                            <span onClick={handleDeleteWhatsAppBot}
                                  className="whatsapp-bot-delete-button">&times;</span>
                        </div>
                    )}

                    {whatsAppBot.attached && (
                        <div style={{
                            background: colors.blueExtraLite3,
                            border: '1px solid ' + colors.blueExtraLite,
                            borderRadius: '8px',
                            padding: '20px',
                            marginBottom: '20px',
                        }}>
                            <div style={{marginBottom: '20px'}}>
                                <div style={{fontWeight: 600, marginBottom: '5px'}}>
                                    Webhook URL
                                </div>

                                <p className="integration-note">
                                    <Translate text="webhookUrlDescription"/>
                                </p>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: 'var(--ds-bg-primary)',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    padding: '8px 12px'
                                }}>
                                <Tooltip text={`${webback}/whatsapp/${client.id}`} needTranslate={false}
                                         style={{minWidth: 0, flex: 1}}>
                                    <span style={{
                                        display: 'block',
                                        fontSize: '13px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}>
                                        {webback}/whatsapp/{client.id}
                                    </span>
                                </Tooltip>

                                    <SilverButton
                                        onClick={() =>
                                            copyToClipboard(
                                                `${webback}/whatsapp/${client.id}`,
                                                "webhook"
                                            )
                                        }
                                        variant={'ghost'}
                                        styles={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '24px',
                                            height: '24px',
                                            padding: '4px',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        {copiedField === "webhook"
                                            ? <CheckIcon width={16} height={16} style={{color: colors.success}}/>
                                            : <CopyIcon width={16} height={16}/>
                                        }
                                    </SilverButton>
                                </div>
                            </div>

                            <div>
                                <div style={{fontWeight: 600, marginBottom: '5px'}}>
                                    Verification Token
                                </div>

                                <p className="integration-note">
                                    <Translate text="webhookTokenDescription"/>
                                </p>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: 'var(--ds-bg-primary)',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    padding: '8px 12px'
                                }}>
                                <Tooltip text={whatsAppBot.verificationToken} needTranslate={false}
                                         style={{minWidth: 0, flex: 1}}>
                                    <span style={{
                                        display: 'block',
                                        fontSize: '13px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}>
                                        {whatsAppBot.verificationToken}
                                    </span>
                                </Tooltip>

                                    <SilverButton
                                        onClick={() =>
                                            copyToClipboard(whatsAppBot.verificationToken, "token")
                                        }
                                        variant={'ghost'}
                                        styles={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '24px',
                                            height: '24px',
                                            padding: '4px',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        {copiedField === "token"
                                            ? <CheckIcon width={16} height={16} style={{color: colors.success}}/>
                                            : <CopyIcon width={16} height={16}/>
                                        }
                                    </SilverButton>
                                </div>
                            </div>
                        </div>
                    )}


                    {whatsAppBot.attached &&
                        <span
                            style={{
                                margin: '6px',
                                fontWeight: 'bold',
                                display: 'inline-block'
                            }}>Business Account ID</span>}
                    <Input
                        value={whatsAppBot.accountId ? whatsAppBot.accountId : ""}
                        type="text"
                        name="accountId"
                        placeholder="Business Account ID"
                        onChange={e => {
                            const value = e.target.value;
                            setWhatsAppBot(prev => {
                                    return {
                                        ...prev,
                                        accountId: value
                                    }
                                }
                            )
                        }
                        }
                        disabled={!!whatsAppBot.attached}
                        style={{

                            marginBottom: '10px'
                        }}
                    />

                    {whatsAppBot.attached &&
                        <span
                            style={{margin: '6px', fontWeight: 'bold', display: 'inline-block'}}>Phone Number ID</span>}
                    <Input
                        value={whatsAppBot.phoneNumberId ? whatsAppBot.phoneNumberId : ""}
                        type="text"
                        name="phoneNumberId"
                        placeholder="Phone Number ID"
                        onChange={e => {
                            const value = e.target.value;
                            setWhatsAppBot(prev => {
                                    return {
                                        ...prev,
                                        phoneNumberId: value
                                    }
                                }
                            )
                        }
                        }
                        disabled={!!whatsAppBot.attached}
                        style={{

                            marginBottom: '10px'
                        }}
                    />

                    {whatsAppBot.attached &&
                        <span style={{margin: '6px', fontWeight: 'bold', display: 'inline-block'}}>App Secret</span>}
                    <Input
                        value={whatsAppBot.appSecret ? whatsAppBot.appSecret : ""}
                        type="text"
                        name="appSecret"
                        placeholder="App Secret"
                        onChange={e => {
                            const value = e.target.value;
                            setWhatsAppBot(prev => {
                                    return {
                                        ...prev,
                                        appSecret: value
                                    }
                                }
                            )
                        }
                        }
                        disabled={!!whatsAppBot.attached}
                        style={{

                            marginBottom: '10px'
                        }}
                    />

                    {whatsAppBot.attached &&
                        <span style={{margin: '6px', fontWeight: 'bold', display: 'inline-block'}}>Access Token</span>}
                    <Input
                        value={whatsAppBot.accessToken ? whatsAppBot.accessToken : ""}
                        type="text"
                        name="accessToken"
                        placeholder="Access Token"
                        onChange={e => {
                            const value = e.target.value;
                            setWhatsAppBot(prev => {
                                    return {
                                        ...prev,
                                        accessToken: value
                                    }
                                }
                            )
                        }
                        }
                        disabled={!!whatsAppBot.attached}
                        style={{}}
                    />

                    <div style={{display: 'flex', justifyContent: 'end',}}>
                        <BlueButton
                            styles={{marginTop: '20px'}}
                            disabled={(!!whatsAppBot.attached || !(whatsAppBot.accountId && whatsAppBot.phoneNumberId && whatsAppBot.accessToken && whatsAppBot.appSecret))}
                            onClick={handleWhatsAppBotSave}
                            width={'135px'}
                            children={<Translate text={'save'}/>}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/integrations/components/Whatsapp.jsx